import React from "react";

const MakersM = (props: React.SVGProps<any>) => (
  <svg width={80} height={80} {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="12.566%" x2="90.081%" y1="11.838%" y2="100%">
        <stop offset="0%" stopColor="#55A2FA" />
        <stop offset="100%" stopColor="#B4EC51" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M40 0c22.063 0 40 17.937 40 40S62.063 80 40 80 0 62.063 0 40 17.937 0 40 0z" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M50.039 34.51l-7.992 16.47h-3.899l-7.992-16.47v18.823h-6.823v-30H32.3l7.603 16.47 7.797-16.47h8.967v30h-6.628z"
      />
    </g>
  </svg>
);

export default MakersM;
